import * as React from "react";
import { Column } from "primereact/column";
import { Row, Col, Modal, ModalHeader, ModalBody, ModalFooter, Button } from "reactstrap";
import PageLayout from "../../components/PageLayout";
import useEntitiesList from "../../utils/listHookNew";
import { DataTable } from "primereact/datatable";
import { DropdownFilterElement, renderHeader } from "../../components/TableUtils";
import { printLabels } from "../../utils/content";
import { DeviceLabelList } from "../../components/Barcode";
import { useAuth0 } from "../../auth/react-auth0-wrapper";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faBarcode } from '@fortawesome/free-solid-svg-icons';
import { Link } from "react-router-dom";
import classNames from 'classnames';

export default function Storage({ opt, activeTenant, showAll }) {
    const { domains } = useAuth0();
    const [openLabels, setOpenLabels] = React.useState();

    let dtable;

    const [result, loading, setLoading, globalFilter, setGlobalFilter, forceRefresh] = useEntitiesList("devices", "", !showAll ? `d.tenant_id = '${activeTenant._id}'` : undefined, "");

    const printLabelsSection = () => (
        <Modal centered isOpen={openLabels ? true : false} backdrop={true}>
            <ModalHeader toggle={() => setOpenLabels(null)}>
                Stampa etichette
      </ModalHeader>
            <ModalBody>
                <DeviceLabelList
                    id="labelsToPrint"
                    items={openLabels ? [openLabels] : []}
                />
            </ModalBody>
            <ModalFooter>
                <div className="float-right mt-5">
                    <Button
                        className="p-button-primary p-button-icon-only"
                        onClick={() => printLabels("labelsToPrint")}
                    >
                        <i className="pi pi-print"></i>
                    </Button>
                </div>
            </ModalFooter>
        </Modal>
    );

    const onRefresh = () => {
        forceRefresh();
        setGlobalFilter("");
    }

    const exportTable = () => {
        dtable.exportCSV();
    }

    return (
        <PageLayout title={`Magazzino - Dealer: ${activeTenant.name}`}>
            <Row>
                <Col>
                    <DataTable
                        ref={el => {
                            dtable = el;
                        }}
                        loading={loading}
                        value={result}
                        rowsPerPageOptions={[5, 10, 20, 50, 100]}
                        className="p-datatable-hoverable-rows p-datatable-customers"
                        responsive
                        paginator={true}
                        autoLayout={false}
                        first={0}
                        rows={20}
                        totalRecords={result.length}
                        paginatorPosition="both"
                        header={renderHeader(loading, result.length, undefined, `Dispositivi in magazzino: ${result.length}`, { globalFilter, setGlobalFilter, onRefresh }, exportTable)}
                        globalFilter={globalFilter}
                        emptyMessage={() => (<div className="text-center">Nessun dispositivo in tabella</div>)}
                        paginatorTemplate="RowsPerPageDropdown CurrentPageReport FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink"
                        currentPageReportTemplate="Visualizzati {first} di {last} Dispositivi su un totale di {totalRecords}"
                    >
                        <Column
                            field="attributes.type"
                            style={{ wordWrap: "break-word" }}
                            header="Tipo"
                            sortable
                            body={el => domains.devicesType.find(item => el.attributes && item.value === el.attributes.type).label}
                            filter
                            filterElement={
                                <DropdownFilterElement
                                    field="attributes.type"
                                    options={domains.devicesType}
                                    onChange={e => dtable.filter(e.value, e.field)}

                                />
                            }
                        />
                        <Column
                            field="attributes.model"
                            header="Modello"
                            sortable
                            filter
                            filterMatchMode="contains"
                            style={{ wordWrap: "break-word" }}
                            body={(rowData) => rowData.attributes.model.toUpperCase()}
                        />
                        <Column
                            field="imei"
                            style={{ wordWrap: "break-word" }}
                            header="IMEI"
                            sortable
                            filter
                            filterMatchMode="contains"
                        />
                        <Column
                            field="serial"
                            header="Seriale"
                            sortable
                            filter
                            filterMatchMode="contains"
                            style={{ wordWrap: "break-word" }}
                        />
                        <Column
                            field="number"
                            header="Telefono"
                            filter
                            filterMatchMode="contains"
                            style={{ wordWrap: "break-word" }}
                        />
                        <Column
                            field="iccid"
                            header="ICCID"
                            style={{ wordWrap: "break-word" }}
                            sortable
                            filter
                        />
                        {showAll && (<Column
                            field="tenant"
                            header="Dealer"
                            sortable
                            filter
                            filterMatchMode="contains"
                            style={{ wordWrap: "break-word" }}
                        />
                        )}
                        <Column
                            field="customer"
                            header="Cliente"
                            sortable
                            filter
                            filterMatchMode="contains"
                            style={{ wordWrap: "break-word" }}
                        />
                        <Column
                            field="status"
                            header="Stato"
                            sortable
                            filter
                            style={{ wordWrap: "break-word", textAlign: "center" }}
                            filterElement={
                                <DropdownFilterElement
                                    field="status"
                                    options={domains.devicesStatus}
                                    onChange={(opt) => {
                                        dtable.filter(opt.value, opt.field, opt.type);
                                    }}
                                />
                            }
                            body={(rowData, column) => {
                                return (
                                    <span className={classNames('customer-badge', 'status-' + rowData.status)}>{rowData.status}</span>
                                );
                            }}
                        />
                        <Column
                            field="actions"
                            body={rowData => {
                                return (
                                    <Button
                                        className="btn btn-sm btn-secondary p-button-icon-only"
                                        onClick={() => setOpenLabels(rowData)}
                                    >
                                        <FontAwesomeIcon icon={faBarcode} />
                                    </Button>
                                );
                            }}
                            style={{ wordWrap: "break-word" }}
                        />
                    </DataTable>
                </Col>
            </Row>
            {printLabelsSection()}
        </PageLayout>
    );
}
